import { ComponentType } from "react";

import { color } from "minimum-ui/tokens";
import styled from "styled-components";
import { H6R } from "typography/captions";
import { H4M } from "typography/headers";

type subtitleProps = {
  label: string;
  additionalInfo?: string;

  labelType?: ComponentType;
  light?: boolean;
};

const Subtitle: React.FC<subtitleProps> = ({
  label,
  additionalInfo,
  light = false,
  labelType = H4M,
  children,
}) => {
  return (
    <Wrapper>
      <div>
        <Title as={labelType} $light={light}>
          {label}
        </Title>
        {additionalInfo && <H6R>{additionalInfo}</H6R>}
      </div>
      <div>{children}</div>
    </Wrapper>
  );
};

const Title = styled.h3<{ $light: boolean }>`
  ${({ $light }) =>
    `color: ${$light ? color.neutral[400] : color.neutral[500]}`}
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export default Subtitle;
